import React from 'react';
import PropTypes from 'prop-types';
import pure from 'recompose/pure';
import moment from 'moment';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

const RelativeDateField = (props) => {
    const { elStyle, source, record = {}, translate } = props;
    let result = translate('fields.datetime.never');
    const data = utils.get(record, source);

    if (data) {
        const utcTime = moment.utc(data).toDate();

        result = moment(utcTime).fromNow();
    }

    return (
        <span style={ elStyle }>
            { result }
        </span>
    );
};

RelativeDateField.propTypes = {
    elStyle: PropTypes.object,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

const PureRelativeDateField = pure(RelativeDateField);

PureRelativeDateField.defaultProps = {
    addLabel: true,
};

export default translate(PureRelativeDateField);



// WEBPACK FOOTER //
// ./src/components/field/RelativeDateField.js